import React from "react";

export const LOADING_STEPS = [
  "Saving your project...",
  "Sending to AI...",
  "Generating your tasks...",
  "Almost there...",
];

interface ProjectLoadingStateProps {
  currentStep: number;
  completedSteps: number[];
}

const ProjectLoadingState: React.FC<ProjectLoadingStateProps> = ({ currentStep, completedSteps }) => (
  <div className="flex flex-col items-center gap-6 py-4 text-center">
    <div className="text-5xl animate-bounce">☕</div>
    <div>
      <div className="text-gray-900 text-base font-semibold font-Inter mb-1">Take a quick break</div>
      <div className="text-gray-500 text-sm font-Inter max-w-[260px] mx-auto leading-relaxed">
        We're working with AI to build the perfect task list for your project.
      </div>
    </div>

    <div className="w-full flex flex-col gap-2.5 text-left">
      {LOADING_STEPS.map((step, i) => {
        const isDone = completedSteps.includes(i);
        const isActive = currentStep === i && !isDone;
        return (
          <div key={i} className="flex items-center gap-3">
            <div
              className={`w-2 h-2 rounded-full flex-shrink-0 transition-colors duration-300 ${
                isDone ? "bg-eai-primary-accent" : isActive ? "bg-eai-primary-accent animate-pulse" : "bg-gray-200"
              }`}
            />
            <span
              className={`text-sm font-Inter transition-colors duration-300 ${
                isDone || isActive ? "text-gray-700 font-medium" : "text-gray-400"
              }`}
            >
              {step}
            </span>
            {isDone && <span className="text-eai-primary-accent text-xs ml-auto">✓</span>}
          </div>
        );
      })}
    </div>
  </div>
);

export default ProjectLoadingState;
